'use client'

import type { UseFormReturn } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { Alert, Button, Stack, TextField, Typography } from '@mui/material'

import { EmailFormData } from '../model/reportLostDeviceForm'

type EmailStepProps = {
  form: UseFormReturn<EmailFormData>
  onSubmit: React.FormEventHandler<HTMLFormElement>
  error: string | null
}

export function EmailStep({ form, onSubmit, error }: EmailStepProps) {
  const submitting = form.formState.isSubmitting
  const email = form.watch('email')

  return (
    <form onSubmit={onSubmit} noValidate>
      <Stack spacing={2}>
        <Typography variant="body2">Pour confirmer votre identité, nous allons vous envoyer un code de vérification à 6 chiffres par email.</Typography>
        <Controller
          name="email"
          control={form.control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Adresse email du compte"
              type="email"
              fullWidth
              autoFocus
              disabled={submitting}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
        {error && <Alert severity="error">{error}</Alert>}
        <Button type="submit" variant="contained" disabled={submitting || !email.trim()}>
          Envoyer le code
        </Button>
      </Stack>
    </form>
  )
}
